// extracted by mini-css-extract-plugin
export default {"header":"StepHeader_header__+sGWv","backButton":"StepHeader_backButton__EenQd","title":"StepHeader_title__1aPkJ"};